import { NgModule, PLATFORM_ID } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@environment';
import { resultsMatcher } from '@shared/url-matchers';
import { DeviceDetectorService } from 'ngx-device-detector';

const routes: Routes = [
  {
    matcher: resultsMatcher,
    loadChildren: () => {
      return import('@angular/core').then(({ Injector }) => {
        const injector = Injector.create({
          providers: [
            { provide: DeviceDetectorService, useClass: DeviceDetectorService },
            { provide: PLATFORM_ID, useValue: 'browser' },
          ],
        });

        const deviceRoutingService = injector.get(DeviceDetectorService);
        return new Promise((resolve) => {
          const isMobile = deviceRoutingService.isMobile() || deviceRoutingService.isTablet();
          if (isMobile) {
            resolve(
              import('./modules/results/mobile/results-mobile.module').then(
                (m) => m.ResultsMobileModule,
              ),
            );
          } else {
            resolve(
              import('./modules/results/desktop/results.module').then((m) => m.ResultsModule),
            );
          }
        });
      });
    },
  },
];
const enableTracing = !environment.production ? { enableTracing: true } : {};
@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, {
      ...enableTracing,
      onSameUrlNavigation: 'reload',
    }),
  ],
})
export class AppRoutingModule {}
